module.exports = __webpack_public_path__ + "static/img/typhoon.ecb8e3f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/typhoon.gif
// module id = cpbf
// module chunks = 2 3